import React from 'react';
import { useTranslation } from 'react-i18next';
import Image from '../../Image';
import "./Card.css";

const Card = ({
  attraction,
  image,
  title = "Jeddah Super Dome",
  desc = "The Jeddah Super Dome will be hosting all local and international exhibitions, conferences, and events, including some of the biggest entertainment, sports, and other cultural events in the city.",
  link,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation('attraction');

  const visit = () => {
    if (!link) return;
    const url = link.includes("https://") ? link : `https://${link}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const canManage = (onEdit || onDelete) && attraction;

  return (
    <div className="card-attraction">
      <Image src={image} />
      <div className="card-details">
        <p className="card-title" title={title}>
          {title}
        </p>
        <p className="card-desc" title={desc}>
          {desc}
        </p>
        {link && (
          <p onClick={visit} className="link">
            {t('card.visit')}
          </p>
        )}
      </div>
      {canManage && (
        <div className="card-action-buttons">
          <button className="edit-btn" type="button" onClick={() => onEdit?.(attraction)}>
            Edit
          </button>
          <button className="delete-btn" type="button" onClick={() => onDelete?.(attraction)}>
            Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default Card;
